export default () => {
  const appDOMNode = dom.querySelector(".render-app-feedback-useful-question");

  let disposeApp: DisposableApp = null;
  let disposing = false;
  if (appDOMNode !== null) {
    import(
      "./index" /* webpackChunkName: "app-feedback-useful-question" */
    ).then(({ default: startApp }) => {
      if (!disposing) {
        disposeApp = startApp(appDOMNode);
      }
    });
  }

  return function disposeCallback() {
    disposing = true;

    if (disposeApp !== null) {
      disposeApp();
    }
  };
};
